export const FETCH_SMS_REJECTED = "FETCH_SMS_REJECTED";
export const SIGNIN_SMS_VERIFICATION_REJECTED = "SIGN_SMS_VERIFICATION_REJECTED";
export const SIGNIN_SMS_VERIFICATION_FORM_SHOW = "SIGNIN_SMS_VERIFICATION_FORM_SHOW";
export const SIGNIN_SMS_VERIFICATION_FORM_HIDE = "SIGNIN_SMS_VERIFICATION_FORM_HIDE";


// WEBPACK FOOTER //
// ./src/constants/signinWithSms.js